import '../css/filters.css';
import { AIR_STRIKE_OPTIONS, INTENSITIES, MARTIAL_STRUCTURE, normalize } from './details';
import { AIR_STRIKE_LABELS, LEFT_ARROW_ICON, RIGHT_ARROW_ICON, SLIDER_SETTINGS } from './filters.details';
import { appState } from './stateManager';
import noUiSlider from 'nouislider';
import 'nouislider/dist/nouislider.css';
import 'overlayscrollbars/overlayscrollbars.css';
import { OverlayScrollbars } from 'overlayscrollbars';

export default class Filters {
	constructor() {
		this.intensityBoxes = [];
		this.martialBoxes = [];
		this.airStrikeBoxes = [];
	}

	init() {
		appState.subscribe(this.onStateChange.bind(this));

		this.setupSearch();
		this.setupIntensities();
		this.setupIntensityBoxes();
		this.setupMartialKeys();
		this.setupAirStrikes();
		this.setupAirStrikeBoxes();
		this.setupReset();

		setTimeout(() => {
			OverlayScrollbars(document.querySelector('#filters-content'), {
				overflow: {
					x: 'hidden',
					y: 'scroll'
				}
			});
		}, 1000);
	}

	setupReset() {
		const btn = document.getElementById('filters-reset-btn');
		btn.addEventListener('click', () => {
			const currentState = appState.getState();
			appState.setState({
				...currentState,
				searchQuery: '',
				intensities: INTENSITIES,
				martialKeys: MARTIAL_STRUCTURE.nemzetiség,
				victims: [this.victimsMin, this.victimsMax],
				tanks: [this.tankMin, this.tankMax],
				days: [this.dayMin, this.dayMax],
				airStrike: AIR_STRIKE_OPTIONS
			});
		});
	}

	setupSearch() {
		this.searchInput = document.getElementById('search-input');
		this.searchInput?.addEventListener('keyup', this.onSearchInput.bind(this));

		const clearBtn = document.getElementById('search-input-clear-btn');
		if (!clearBtn) return;
		clearBtn.onclick = () => {
			if (!this.searchInput) return;
			this.searchInput.value = '';
			const currentState = appState.getState();
			const searchQuery = normalize(this.searchInput.value || '') || '';
			appState.setState({ ...currentState, searchQuery });
		};
	}

	onSearchInput(event) {
		if (event.key === 'Enter') {
			const currentState = appState.getState();
			const searchQuery = normalize(this.searchInput?.value || '') || '';
			appState.setState({ ...currentState, searchQuery });
		}
	}

	setupAirStrikes() {
		const airStrikeOptions = AIR_STRIKE_OPTIONS;
		const labels = AIR_STRIKE_LABELS;
		const wrapper = document.getElementById('air-strike-filters');
		if (!wrapper) return;

		airStrikeOptions.forEach((option) => {
			const airStrikeWrapper = document.createElement('div');
			airStrikeWrapper.classList.add('air-strike-filter');
			const airStrikeBox = document.createElement('input');
			airStrikeBox.type = 'checkbox';
			airStrikeBox.value = String(+option);
			airStrikeBox.checked = true;
			airStrikeBox.id = `air-strike-${option}`;
			airStrikeBox.name = `air-strike-${option}`;
			airStrikeWrapper.appendChild(airStrikeBox);
			const airStrikeLabel = document.createElement('label');
			airStrikeLabel.htmlFor = `air-strike-${option}`;
			airStrikeLabel.textContent = labels[+option];
			airStrikeWrapper.appendChild(airStrikeLabel);
			wrapper.appendChild(airStrikeWrapper);
			this.airStrikeBoxes.push(airStrikeBox);
		});
	}

	setupAirStrikeBoxes() {
		this.airStrikeBoxes?.forEach((box) => {
			box.addEventListener('click', () => {
				this.onAirStrikeBoxClick();
			});
		});
	}

	onAirStrikeBoxClick() {
		const airStrike = [];
		for (const box of this.airStrikeBoxes) {
			const value = box.value;
			const option = parseInt(value) ? true : false;
			const isChecked = box.checked;
			if (isChecked) airStrike.push(option);
		}
		const currentState = appState.getState();
		appState.setState({ ...currentState, airStrike });
	}

	setupIntensities() {
		const intensities = INTENSITIES;
		const intensitiesWrapper = document.querySelector('#intensities-filters');
		if (!intensitiesWrapper) return;
		intensities.forEach((intensity) => {
			const intensityWrapper = document.createElement('div');
			intensityWrapper.classList.add('intensity-filter');
			const intensityBox = document.createElement('input');
			intensityBox.type = 'checkbox';
			intensityBox.value = intensity;
			intensityBox.checked = true;
			intensityBox.id = `intensity-${intensity}`;
			intensityBox.name = `intensity-${intensity}`;
			intensityWrapper.appendChild(intensityBox);
			const intensityLabel = document.createElement('label');
			intensityLabel.htmlFor = `intensity-${intensity}`;
			intensityLabel.textContent = intensity;
			intensityWrapper.appendChild(intensityLabel);
			intensitiesWrapper.appendChild(intensityWrapper);
			this.intensityBoxes.push(intensityBox);
		});
	}

	setupIntensityBoxes() {
		this.intensityBoxes?.forEach((box) => {
			box.addEventListener('click', () => {
				this.onIntensityBoxClick();
			});
		});
	}

	onIntensityBoxClick() {
		const intensities = [];
		for (const box of this.intensityBoxes) {
			const value = box.value;
			const isChecked = box.checked;
			if (isChecked) intensities.push(value);
		}
		const currentState = appState.getState();
		appState.setState({ ...currentState, intensities });
	}

	setupMartialKeys() {
		const wrapper = document.getElementById('martial-keys-filters');
		if (!wrapper) return;

		const nationalities = MARTIAL_STRUCTURE.nemzetiség;
		const fragment = new DocumentFragment();
		for (const nationality of nationalities) {
			const element = this.getMartialKeyElement(nationality);
			this.martialBoxes.push(element.children[0]);
			fragment.appendChild(element);
		}
		wrapper.appendChild(fragment);
	}

	getMartialKeyElement(value) {
		const element = document.createElement('div');
		element.classList.add('martial-key-element');
		const checkbox = document.createElement('input');
		checkbox.type = 'checkbox';
		checkbox.value = value;
		checkbox.checked = true;
		const id = `martial-key-${value.split(' ').join('-')}`;
		checkbox.id = id;
		checkbox.addEventListener('change', () => {
			this.onMartialKeyChange();
		});
		element.appendChild(checkbox);
		const label = document.createElement('label');
		label.htmlFor = id;
		label.innerHTML = value;
		element.appendChild(label);
		return element;
	}

	onMartialKeyChange() {
		const presentKeys = [];
		this.martialBoxes.forEach((box) => {
			if (box.checked) presentKeys.push(box.value);
		});
		const currentState = appState.getState();
		appState.setState({ ...currentState, martialKeys: presentKeys });
	}

	setupDays(data) {
		if (this.daySlider) return;
		const wrapper = document.getElementById('days-slider');
		if (!wrapper) return;
		const range = this.getRange(data, 'A harctevékenység időtartama (naptári nap)');
		this.dayMin = range.min;
		this.dayMax = range.max;
		this.daySlider = this.getSlider(wrapper, range);
		this.daySlider.on('slide', (values) => {
			const lowerDays = parseInt(values[0]);
			const upperDays = parseInt(values[1]);
			this.onDaysSlide(lowerDays, upperDays);
		});
	}

	onDaysSlide(lowerDays, upperDays) {
		const currentState = appState.getState();
		appState.setState({ ...currentState, days: [lowerDays, upperDays] });
	}

	setupTanks(data) {
		if (this.tanksSlider) return;
		const wrapper = document.getElementById('tanks-slider');
		if (!wrapper) return;
		const range = this.getRange(data, 'Páncélosok alkalmazása');
		this.tankMin = range.min;
		this.tankMax = range.max;
		this.tanksSlider = this.getSlider(wrapper, range);
		this.tanksSlider.on('slide', (values) => {
			const lowerTanks = parseInt(values[0]);
			const upperTanks = parseInt(values[1]);
			this.onTanksSlide(lowerTanks, upperTanks);
		});
	}

	onTanksSlide(lowerTanks, upperTanks) {
		const currentState = appState.getState();
		appState.setState({ ...currentState, tanks: [lowerTanks, upperTanks] });
	}

	setupVictims(data) {
		if (this.victimsSlider) return;
		const wrapper = document.getElementById('victims-slider');
		if (!wrapper) return;
		const range = this.getRange(data, 'numRecords');
		this.victimsMin = range.min;
		this.victimsMax = range.max;
		this.victimsSlider = this.getSlider(wrapper, range);
		this.victimsSlider.on('slide', (values) => {
			const lowerVictims = parseInt(values[0]);
			const upperVictims = parseInt(values[1]);
			this.onVictimsSlide(lowerVictims, upperVictims);
		});
	}

	onVictimsSlide(lowerVictims, upperVictims) {
		const currentState = appState.getState();
		appState.setState({ ...currentState, victims: [lowerVictims, upperVictims] });
	}

	getRange(data, key) {
		const uniqueValues = [];
		for (const item of data) {
			const value = parseInt(item[key]) || 0;
			if (value === null || isNaN(value)) continue;
			if (!uniqueValues.includes(value)) uniqueValues.push(value);
		}
		uniqueValues.sort((a, b) => a - b);
		const step = 100 / (uniqueValues.length - 1);
		const range = {};
		uniqueValues.forEach((uniqueValue, i) => {
			const pct = (i * step).toFixed(2) + '%';
			range[pct] = uniqueValue;
		});
		range.min = uniqueValues[0];
		range.max = uniqueValues[uniqueValues.length - 1];
		return range;
	}

	getSlider(wrapper, range) {
		return noUiSlider.create(wrapper, {
			start: [range.min, range.max],
			range,
			...SLIDER_SETTINGS,
			tooltips: [
				{
					to: (value) => this.getTooltipValue(value, false)
				},
				{
					to: (value) => this.getTooltipValue(value, true)
				}
			]
		});
	}

	getTooltipValue(value, isRight = false) {
		return `<div class="tooltip-value">${value}</div><div class="tooltip-dot">${isRight ? RIGHT_ARROW_ICON : LEFT_ARROW_ICON}</div>`;
	}

	updateIntensities(intensities) {
		for (const box of this.intensityBoxes) {
			const value = box.value;
			box.checked = intensities.includes(value);
		}
	}

	updateMartialKeys(martialKeys) {
		for (const box of this.martialBoxes) {
			const value = box.value;
			box.checked = martialKeys.includes(value);
		}
	}

	updateAirStrikeBoxes(airStrikeOptions) {
		for (const box of this.airStrikeBoxes) {
			const value = box.value;
			const option = !!parseInt(value);
			box.checked = airStrikeOptions.includes(option);
		}
	}

	updateSliders(victims, days, tanks) {
		const victimsValues = this.victimsSlider?.get().map((value) => parseInt(value));
		const daysValues = this.daySlider?.get().map((value) => parseInt(value));
		const tanksValues = this.tanksSlider?.get().map((value) => parseInt(value));
		if (victimsValues[0] !== victims[0] || victimsValues[1] !== victims[1]) {
			this.victimsSlider?.set([victims[0], victims[1]]);
		}
		if (daysValues[0] !== days[0] || daysValues[1] !== days[1]) {
			this.daySlider?.set([days[0], days[1]]);
		}
		if (tanksValues[0] !== tanks[0] || tanksValues[1] !== tanks[1]) {
			this.tanksSlider?.set([tanks[0], tanks[1]]);
		}
	}

	updateSearch(searchQuery) {
		const currentQuery = this.searchInput?.value || '';
		if (currentQuery !== searchQuery) {
			this.searchInput.value = searchQuery;
		}
	}

	onStateChange(state) {
		if (!state.data || !state.data.length) return;
		this.setupVictims(state.data);
		this.setupDays(state.data);
		this.setupTanks(state.data);

		this.updateIntensities(state.intensities);
		this.updateMartialKeys(state.martialKeys);
		this.updateAirStrikeBoxes(state.airStrike);
		this.updateSliders(state.victims, state.days, state.tanks);
		this.updateSearch(state.searchQuery);
	}
}
